import { useNavigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
const Unauthorzied = () => {
  const navigate = useNavigate()
  const goBack = () => navigate(-1)

  return (
    <>
      <h1>unauthorzied</h1>
      <button onClick={goBack}>Go Back</button>
    </>
  )
}

export default Unauthorzied
